<template>
  <div class="create-edit-pet-modal petit-nature-modal">
    <div class="header">
      <h1 class="subtitle is-4" v-if="isCreate">Nova entrega</h1>
      <h1 class="subtitle is-4" v-else>Editar entrega</h1>
      <span class="close-button" @click="$emit('close')">
        <i class="mdi mdi-window-close"></i>
      </span>
    </div>
    <div class="body">
      <div class="columns is-multiline">
        <div class="column is-6">
          <b-field label="Pet">
            <b-autocomplete
              expanded
              v-model="petSearchText"
              :data="petsList"
              placeholder="Buscar pet"
              field="name"
              :loading="isFetching"
              :keep-first="true"
              @keyup.native="getPetAsyncData"
              @select="selectPet"
            >
              <template slot-scope="props">
                <span
                  >{{ props.option.name }} -
                  <b>{{ props.option.owner.name }}</b></span
                >
              </template>
              <template slot="empty">
                Nenhum resultado encontrado
              </template>
            </b-autocomplete>
          </b-field>
        </div>
        <div class="column is-6" v-if="delivery.deliveryDate">
          <b-field label="Data de entrega">
            <b-datepicker v-model="delivery.deliveryDate" icon="calendar-today">
            </b-datepicker>
          </b-field>
        </div>
        <div class="column is-6" style="padding-top: 42px">
          <button
            class="button is-primary"
            @click="addDeliveryCustomer"
            v-if="selectedPet && selectedPet.id"
          >
            Adicionar
          </button>
        </div>

        <div
          class="column is-12"
          v-for="deliveryCustomer in delivery.deliveryCustomers"
          :key="deliveryCustomer.id"
        >
          <delivery-customer-component
            @removePet="removePet(deliveryCustomer)"
            :item="deliveryCustomer"
          ></delivery-customer-component>
        </div>
      </div>
    </div>
    <div class="footer has-text-right">
      <button
        type="submit"
        class="button is-primary"
        :class="{ 'is-loading': isPendingAction }"
        :disabled="isPendingAction"
        @click="save()"
      >
        Salvar
      </button>
    </div>
  </div>
</template>

<script>
import DeliveryCustomerComponent from "./DeliveryCustomerComponent";
import QueryBuilder from "../../helpers/QueryBuilder";
import utils from "../../helpers/debounce";
import PetService from "../../services/PetService";
import DefaultCRUDService from "../../services/DefaultCRUDService";
import NotificationsWrapper from "../../helpers/NotificationsWrapper";
import { HTTP } from "../../services/HttpServices";

export default {
  name: "CreateEditDeliveryModal",
  components: { DeliveryCustomerComponent },
  props: ["deliveryParam"],
  data: function() {
    return {
      delivery: {},
      isCreate: true,
      isFetching: false,
      petSearchText: "",
      petsList: [],
      selectedPet: {},
      isPendingAction: false
    };
  },
  methods: {
    save() {
      if (this.isCreate) {
        delete this.delivery.id;
      }
      this.delivery.deliveryCustomers.forEach(item => {
        if (item.newDelivery) {
          delete item.id;
        }
        item.deliveryProducts = item.deliveryProducts.filter(i => i.packedProduct.batch && i.packedProduct.batch.length);
        item.deliveryProducts.forEach(it => {
          if (it.newPackedProduct) {
            delete it.id;
          }
        });
      });
      this.isPendingAction = true;
      DefaultCRUDService.createOrUpdate("deliveries", this.delivery)
        .then(({ data }) => {
          NotificationsWrapper.success("Entrega criada com sucesso!");
          this.isPendingAction = false;
          this.$emit("close");
        })
        .catch(error => {
          NotificationsWrapper.error("Houve um erro ao criar a entrega.");
          this.isPendingAction = false;
          console.log(error);
        });
    },
    addDeliveryCustomer() {
      this.delivery.deliveryCustomers.push({
        id: new Date().getTime(),
        pet: this.selectedPet,
        deliveryProducts: [],
        newDelivery: true
      });
      this.selectedPet = undefined;
    },
    removePet(deliveryCustomer) {
      this.delivery.deliveryCustomers = this.delivery.deliveryCustomers.filter(
        dc => {
          return dc.id !== deliveryCustomer.id;
        }
      );
    },
    selectPet(option) {
      this.selectedPet = option;
      this.petSearchText = "";
    },
    getPetAsyncData: utils.debounce(function() {
      this.petsList = [];
      let query = {
        name: this.petSearchText,
        size: 5
      };
      query = QueryBuilder.getQueryString(query);
      this.isFetching = true;
      PetService.getPets(query)
        .then(({ data }) => {
          let aux = [];
          //remove already added pets from list
          data.content.forEach(pet => {
            let exists = false;
            this.delivery.deliveryCustomers.forEach(dc => {
              if (dc.pet.id === pet.id) {
                exists = true;
              }
            });
            if (!exists) {
              aux.push(pet);
            }
          });
          this.petsList = aux;
        })
        .finally(() => (this.isFetching = false));
    }, 300)
  },
  created() {
    if (this.deliveryParam.id) {
      HTTP.get("deliveries/" + this.deliveryParam.id).then(({ data }) => {
        this.isCreate = false;
        this.delivery = data;
        this.delivery.deliveryDate = new Date(this.delivery.deliveryDate);
      });
    } else {
      this.isCreate = true;
      this.delivery = { deliveryCustomers: [], deliveryDate: new Date() };
    }
  }
};
</script>

<style scoped></style>
